import React from 'react';

const OverrideConfirmationModal = ({ pendingOverrides, handleOverrideCancel, handleOverrideConfirm }) => {
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white p-6 rounded-lg max-w-2xl w-full mx-4">
        <h3 className="text-xl font-bold mb-4">Update Site Information?</h3>
        <p className="text-gray-600 mb-4">
          The following information was found. Would you like to update these fields?
        </p>
        <div className="space-y-4 mb-6">
          {pendingOverrides.overrides.map(({ field, current, new: newValue }) => (
            <div key={field} className="border-b pb-4">
              <div className="font-medium text-gray-700 capitalize mb-2">{field}</div>
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <div className="text-sm text-gray-500">Current</div>
                  <div className="text-gray-700">{current}</div>
                </div>
                <div>
                  <div className="text-sm text-gray-500">New</div>
                  <div className="text-gray-700">{newValue}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
        <div className="flex gap-4 justify-end">
          <button
            onClick={handleOverrideCancel}
            className="px-4 py-2 text-gray-600 hover:text-gray-800"
          >
            Keep Current Values
          </button>
          <button
            onClick={handleOverrideConfirm}
            className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
          >
            Update Values
          </button>
        </div>
      </div>
    </div>
  );
};

export default OverrideConfirmationModal;
